import { render, staticRenderFns } from "./SectionNewReview.vue?vue&type=template&id=f5350534&scoped=true&lang=pug&"
import script from "./SectionNewReview.vue?vue&type=script&lang=js&"
export * from "./SectionNewReview.vue?vue&type=script&lang=js&"
import style0 from "./SectionNewReview.vue?vue&type=style&index=0&id=f5350534&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5350534",
  null
  
)

export default component.exports